import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

export const StyledMaxMinInput = styled(Form.Control)`
  ${({ width }) => (width ? `width: ${width};` : '')}
`;

export default StyledMaxMinInput;
